@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="edittablebdr m-0">
  <div class="rtnav ui-g">
    <div class="ui-g-8 msgbox-6">
      @for (message of msgsEngDetails; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
    </div>
    @if (!btnNavEngDetails) {
      <div class="ui-g-3"></div>
    }
    @if (btnNavEngDetails) {
      <div class="ui-g-3">
        <button
          type="button"
          pButton
          (click)="editEventDetailsCancel()"
          class="ui-button-secondary flat fl-rt">
          Cancel
        </button>
        <button
          type="submit"
          pButton
          (click)="onSubmitEventDetails(formEventDetails)"
          class="flat btnmr fl-rt">
          Save
        </button>
      </div>
    }
    <div class="ui-g-1 edit-history-icon">
      <span
        class="fa fa-pencil ico cpointer fl-rt"
        pTooltip="Edit"
        (click)="editEventDetails()"
        (keydown.enter)="editEventDetails()"
        tabindex="0"
        tooltipPosition="bottom"></span>
    </div>
  </div>
  <form [formGroup]="formEventDetails" #localForm="ngForm">
    <div class="readonlytbox">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Market Price</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlyEng"
            (keypress)="numberOnly($event)"
            formControlName="qualifiedAmount" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Market</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input type="text" pInputText readonly formControlName="market" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      @if (!isDealAssociation) {
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Task Owner</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-select
              appendTo="body"
              [options]="taskOwnerDrpdwn"
              [readonly]="isReadonlyEng"
              formControlName="taskOwner"
              [class.readonlydd]="isReadonlyEng === true"
              placeholder="--SELECT--"
              optionLabel="taskOwner"></p-select>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
      }
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">PMO Next Steps</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-select
            appendTo="body"
            [options]="pmoNextStepStatus"
            [readonly]="isReadonlyEng"
            formControlName="pMONextSteps"
            dataKey="eventPmonextStepId"
            [class.readonlydd]="isReadonlyEng === true"
            placeholder="--SELECT--"
            optionLabel="name"></p-select>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">L1 Internal Status</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-select
            appendTo="body"
            [options]="l1InternalStatuses"
            [readonly]="isReadonlyEng"
            formControlName="t1InternalStatus"
            [class.readonlydd]="isReadonlyEng === true"
            placeholder="--SELECT--"
            optionLabel="name"></p-select>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Ops Status</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-select
            appendTo="body"
            [options]="l2InternalStatuses"
            [readonly]="isReadonlyEng"
            formControlName="opsStatus"
            [class.readonlydd]="isReadonlyEng === true"
            placeholder="--SELECT--"
            dataKey="eventL2internalStatusId"
            optionLabel="name"></p-select>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      @if (!isDealAssociation) {
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone Payment Status</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-select
              appendTo="body"
              [options]="milestonePaymentStatuses"
              [readonly]="isReadonlyEng"
              formControlName="milestonePaymentStatus"
              [class.readonlydd]="isReadonlyEng === true"
              placeholder="--SELECT--"
              optionLabel="milestonePaymentStatusName"></p-select>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Decline Reasons</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-select
              appendTo="body"
              [options]="declineReasons"
              [readonly]="isReadonlyEng"
              formControlName="declineReason"
              [class.readonlydd]="isReadonlyEng === true"
              placeholder="--SELECT--"
              optionLabel="declineReason"></p-select>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
      }
      <div class="ui-g">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="hdbl">Key Dates</div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Engagement Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            appendTo="body"
            class="readonly-calendar"
            formControlName="eventDate"
            dateFormat="mm/dd/yy"
            placeholder="mm/dd/yy"
            [readonlyInput]="true"
            [defaultDate]="maxYearDate"
            [showOnFocus]="false"
            [showIcon]="false"
            [iconDisplay]="'input'"
            [class.readonlycaltb]="false">
          </p-datepicker>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Eligible Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            appendTo="body"
            formControlName="eligibleDate"
            dateFormat="mm/dd/yy"
            placeholder="mm/dd/yy"
            inputId="basic"
            [readonlyInput]="isReadonlyEng"
            [defaultDate]="maxYearDate"
            [showOnFocus]="!isReadonlyEng"
            [showIcon]="!isReadonlyEng"
            [iconDisplay]="'input'"
            [class.readonlycaltb]="isReadonlyEng">
          </p-datepicker>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      @if (hasCustomerAcknowledgement) {
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            Days since customer confirmation agreement email sent (cancel after
            30 days)
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <input
              type="text"
              pInputText
              (keypress)="numberOnly($event)"
              readonly
              formControlName="daysSinceCustomer" />
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Ack Reminder Sent</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-datepicker
              appendTo="body"
              formControlName="thirtyDayReminderSentDate"
              dateFormat="mm/dd/yy"
              placeholder="mm/dd/yy"
              [readonlyInput]="isReadonlyEng"
              [defaultDate]="maxYearDate"
              [showOnFocus]="!isReadonlyEng"
              [showIcon]="!isReadonlyEng"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyEng">
            </p-datepicker>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            Customer Ack Expiration Sent
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-datepicker
              appendTo="body"
              formControlName="day30ExpirationDate"
              dateFormat="mm/dd/yy"
              placeholder="mm/dd/yy"
              [readonlyInput]="isReadonlyEng"
              [defaultDate]="maxYearDate"
              [showOnFocus]="!isReadonlyEng"
              [showIcon]="!isReadonlyEng"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyEng">
            </p-datepicker>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
      }
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">POE Expiration Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            appendTo="body"
            formControlName="day90ExpirationDate"
            dateFormat="mm/dd/yy"
            placeholder="mm/dd/yy"
            class="readonly-calendar"
            [readonlyInput]="true"
            [defaultDate]="maxYearDate"
            [showOnFocus]="false"
            [showIcon]="false"
            [iconDisplay]="'input'"
            [class.readonlycaltb]="false">
          </p-datepicker>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          Days Left From POE Expiration Date
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            (keypress)="numberOnly($event)"
            readonly
            formControlName="daysLeftFromDay90ExpirationDate" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Date Engagement Cancelled</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            formControlName="cancelledDate"
            readonly
            [class.readonlydd]="isReadonlyEng === true"
            type="text"
            pInputText />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Engagement Extended</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          @if (isReadonlyEng) {
            <div>
              <input
                type="checkbox"
                [disabled]="true"
                formControlName="isEventExtended" />
            </div>
          }
          @if (!isReadonlyEng) {
            <div>
              <input
                formControlName="isEventExtended"
                type="checkbox"
                [disabled]="isReadonlyEng"
                (click)="onCheckedEventExtended()" />
            </div>
          }
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Extended Expiration Date</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <p-datepicker
            appendTo="body"
            formControlName="extendedExpirationDate"
            dateFormat="mm/dd/yy"
            placeholder="Click to select date"
            [ngClass]="{
              extend_expiration_calendar:
                localForm.submitted &&
                formEventDetails.get('extendedExpirationDate')?.invalid &&
                isEventExtendedEnable &&
                !isReadonlyEng
            }"
            [required]="isEventExtendedEnable"
            [minDate]="dateTime"
            [class.readonlycaltb]="isReadonlyEng"
            hourFormat="12"
            inputId="basic"
            [readonlyInput]="isReadonlyEng"
            [showOnFocus]="!isReadonlyEng"
            [showIcon]="!isReadonlyEng"
            [iconDisplay]="'input'"></p-datepicker>
        </div>
        @if (
          !isReadonlyEng &&
          localForm.submitted &&
          formEventDetails.get('extendedExpirationDate')?.invalid &&
          isEventExtendedEnable
        ) {
          <div
            class="ui-g-12 ui-md-4 ui-lg-4"
            [ngClass]="{
              'extend-expiration-fails':
                localForm.submitted &&
                formEventDetails.get('extendedExpirationDate')?.invalid
            }">
            <span>Please enter Extended Expiration Date</span>
          </div>
        }
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      @if (!isDealAssociation) {
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 End Date</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-datepicker
              appendTo="body"
              formControlName="activityEligibilityEndDate"
              dateFormat="mm/dd/yy"
              placeholder="mm/dd/yy"
              class="readonly-calendar"
              [readonlyInput]="true"
              [defaultDate]="maxYearDate"
              [showOnFocus]="false"
              [showIcon]="false"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="false">
            </p-datepicker>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Committed Date</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-datepicker
              appendTo="body"
              formControlName="committedDate"
              dateFormat="mm/dd/yy"
              placeholder="mm/dd/yy"
              [readonlyInput]="isReadonlyEng"
              [defaultDate]="maxYearDate"
              [showOnFocus]="!isReadonlyEng"
              [showIcon]="!isReadonlyEng"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyEng">
            </p-datepicker>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
      }
      @if (hasCustomerAcknowledgement) {
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            Customer Acknowledgement Date
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-datepicker
              appendTo="body"
              formControlName="committedEmailSent"
              dateFormat="mm/dd/yy"
              placeholder="mm/dd/yy"
              [readonlyInput]="isReadonlyEng"
              [defaultDate]="maxYearDate"
              [showOnFocus]="!isReadonlyEng"
              [showIcon]="!isReadonlyEng"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyEng">
            </p-datepicker>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <button
              type="button"
              pButton
              (click)="openDocumentUpload()"
              pTooltip="Upload or View"
              tooltipPosition="top"
              class="ui-button-info btnpad btnmr">
              Customer Acknowledgement
            </button>
            <a
              pTooltip="Download Template"
              tooltipPosition="top"
              (click)="downloadOFT()"
              (keydown.enter)="downloadOFT()"
              tabindex="0"
              >Download</a
            >
          </div>
        </div>
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            Customer Acknowledgement Status
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <input
              type="text"
              pInputText
              readonly
              formControlName="customerAckStatus" />
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            Days since Committed Email Sent (cancel after 90 days)
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <input
              type="text"
              pInputText
              (keypress)="numberOnly($event)"
              readonly
              formControlName="daysSinceCommittedEmailSent" />
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
      }
      @if (
        hasCustomerAcknowledgement ||
        checkEventType(EventType.TeamsRoomsOneToMany)
      ) {
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">POE Reminder Sent</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <p-datepicker
              appendTo="body"
              formControlName="reminderSentDate"
              dateFormat="mm/dd/yy"
              placeholder="mm/dd/yy"
              [readonlyInput]="isReadonlyEng"
              [defaultDate]="maxYearDate"
              [showOnFocus]="!isReadonlyEng"
              [showIcon]="!isReadonlyEng"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyEng">
            </p-datepicker>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
      }
    </div>
  </form>
</div>

<p-dialog
  [(visible)]="loadcustomAck"
  class="dg-model"
  [contentStyle]="{
    'max-height': '550px',
    'overflow-y': 'auto',
    width: '700px',
    'z-index': '10027px'
  }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="false"
  [focusOnShow]="false">
  <ng-template #header>
    <div class="ui-g-11 dg-title">{{ fileUploadHeader }}</div>
    <div
      class="ui-g-1 closesidebar diaclnav dg-close"
      (click)="closeDocumentUpload()"
      (keydown.enter)="closeDocumentUpload()"
      tabindex="0">
      <i class="mdl2-cancel cpointer" style="float: right; color: #212121"></i>
    </div>
  </ng-template>

  <div class="tolFile">
    <p>
      File size must be less than 10 MB.
      <span>Acceptable file types: image or pdf</span>
    </p>
  </div>
  <div class="tolFile">
    <p><b>Note: </b>Drag and Drop/Browse files will be Uploaded to Server.</p>
  </div>
  @for (message of umsgs; track message) {
    <p-message [life]="3000" [text]="message.detail"></p-message>
  }
  <div
    class="uploadfilecontainer"
    appDragDrop
    (onFileDropped)="uploadFile($any($event))">
    <div><i class="fa fa-cloud-upload fa-lg"></i></div>
    Drag and drop files here or
    <a
      (click)="fileInputUpload.click()"
      (keydown.enter)="fileInputUpload.click()"
      tabindex="0"
      >Browse</a
    >
    <input
      hidden
      type="file"
      #fileInputUpload
      (change)="uploadFile($any($event.target).files)" />
  </div>
  @if (filesUpload) {
    <div class="tolFile">
      <p>
        Total Number of File in Uploading:
        {{ filesUpload.length }}
      </p>
    </div>
  }
  <div class="files-list listtable">
    <table>
      <tr *ngFor="let file of filesUpload; let i = index">
        <td>{{ file.fileName }}</td>
        <td class="tdwidth">
          @if (fileUploadSpinners[i] !== true) {
            <i class="fa fa-check-circle"></i>
          }
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
        <td class="tdwidth">
          @if (fileUploadSpinners[i] !== true) {
            <span>{{ formatBytes(file?.size, 0) }}</span>
          }
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
      </tr>
    </table>
  </div>
  <div class="tolFile">
    <p>Files in List</p>
  </div>
  <div class="files-list listtable">
    <table>
      <thead>
        <tr>
          <th width="7">File Name</th>
          <th class="tdwidth">Preview</th>
          <th class="tdwidth">Download</th>
          <th class="tdwidth">Delete</th>
        </tr>
      </thead>
      <tr *ngFor="let file of customerAck; let i = index">
        <td>
          @if (downloadSpin[i] === true) {
            <img
              src="../../../assets/images/download.gif"
              alt="download"
              width="7" />
          }
          {{ file.fileName }}
        </td>
        <td class="tdwidth">
          @if (canShowPreviewButton($any(file.fileName))) {
            <a aria-disabled="true" class="disabled">
              <i
                class="fa fa-file fa-lg disabled-icon"
                aria-hidden="true"
                pTooltip="Preview"
                tooltipPosition="bottom"></i>
            </a>
          }
        </td>
        <td class="tdwidth">
          <a
            (click)="downloadFile(i)"
            (keydown.enter)="downloadFile(i)"
            tabindex="0">
            <i
              class="fa fa-download fa-lg"
              aria-hidden="true"
              pTooltip="Download"
              tooltipPosition="bottom"></i>
          </a>
        </td>
        <td class="tdwidth">
          <a
            (click)="deleteAttachment(i)"
            (keydown.enter)="deleteAttachment(i)"
            tabindex="0">
            <i
              class="fa fa-remove fa-lg"
              aria-hidden="true"
              pTooltip="Delete"
              tooltipPosition="bottom"></i>
          </a>
        </td>
      </tr>
    </table>
  </div>
  <br />
  <div class="btn-box">
    <button type="submit" pButton (click)="saveFile()" class="flat btnmr">
      Submit
    </button>
    <button
      type="button"
      pButton
      (click)="closeDocumentUpload()"
      class="ui-button-secondary flat">
      Cancel
    </button>
  </div>
</p-dialog>
